export const SET_APP_EVENTS = 'Web.TemplatesInterface.v1_0.Touch.ChromeTemplateInterface.SetAppEventsMethod';
export const NETWORK_CONNECTIVITY_CHANGE = 'NetworkConnectivityChange';
